<div *ngIf="isloader" class="h-100 w-100 padt-5">
    <mat-progress-bar [mode]="'indeterminate'">
    </mat-progress-bar>
</div>
<div class="d-flex flex-column reminder-justify-content-center" *ngIf="!isloader && !isError">
    <div class="d-flex w-100">
        <div class="vehicle-profile-header widget-title">{{widgetData?.title}}</div>
        <div class="ml-auto disabled">View all</div>
    </div>
    <!-- <div class="d-flex gp-10 tile-min-h" *ngIf="tenantDetails?.tenant!=='UFC'">
        <div class="vehicle-values flex1 bg-tile text-center">
            <div class="rem-img-fit"><img src="../../../../assets/images/fluent-mdl2_service-off.svg" alt=""
                    class="img-fluid h-60"></div>
            <div class="rem-name">Service</div>
            <div class="ft-12 d-flex rem-due">
                <span>Due On&nbsp;</span>{{reminderData?.certificateDetails?.rc | date: 'dd/MM/yyyy'}}
            </div>
        </div>
    </div> -->
    <div class="d-flex gp-10 tile-min-h" *ngIf="tenantDetails?.tenant!=='DMK' && tenantDetails?.tenant!=='UFC' && tenantDetails?.tenant!=='CIC'">
        <div class="vehicle-values flex1 bg-tile text-center">
            <div class="rem-img-fit"><img src="../../../../assets/images/mdi_car-insurance.svg" alt=""
                    class="img-fluid h-80"></div>
            <div class="rem-name">Insurance</div>
            <div class="ft-12 d-flex rem-due">
                <span>Due On&nbsp;</span>{{reminderData?.certificateDetails?.insurance | date: 'dd/MM/yyyy'}}
            </div>
        </div>
        <div class="vehicle-values flex1 bg-tile text-center">
            <div class="rem-img-fit"><img src="../../../../assets/images/carbon_certificate-check.svg" alt=""
                    class="img-fluid h-68"></div>
            <div class="rem-name">Pollution</div>
            <div class="ft-12 d-flex rem-due">
                <span>Due On&nbsp;</span>{{reminderData?.certificateDetails?.pollution | date: 'dd/MM/yyyy'}}
            </div>
        </div>
        <div class="vehicle-values flex1 bg-tile text-center">
            <div class="rem-img-fit"><img src="../../../../assets/images/fluent-mdl2_service-off.svg" alt=""
                    class="img-fluid h-60"></div>
            <div class="rem-name">Service</div>
            <div class="ft-12 d-flex rem-due">
                <span>Due On&nbsp;</span>{{reminderData?.certificateDetails?.rc | date: 'dd/MM/yyyy'}}
            </div>
        </div>
    </div>
    <div class="d-flex gp-10 tile-min-h" *ngIf="tenantDetails?.tenant==='UFC' || tenantDetails?.tenant==='CIC'">
        <div class="vehicle-values flex1 bg-tile text-center">
            <div class="rem-img-fit"><img src="../../../../assets/images/fluent-mdl2_service-off.svg" alt=""
                    class="img-fluid h-60"></div>
            <div class="rem-name">Service</div>
            <div class="ft-12 d-flex rem-due">
                <span>Due On&nbsp;</span>{{reminderData?.certificateDetails?.service | date: 'dd/MM/yyyy'}}
            </div>
        </div>
    </div>
    <div class="d-flex gp-10 tile-min-h" *ngIf="tenantDetails?.tenant==='DMK'">
        <div class="vehicle-values flex1 bg-tile text-center">
            <div class="rem-img-fit"><img src="../../../../../../assets/images/warranty_dmk.svg" alt=""
                    class="img-fluid h-80"></div>
            <div class="rem-name">Warranty</div>
            <div class="ft-12 d-flex rem-due">
                <span>Due On&nbsp;</span>{{reminderData?.certificateDetails?.warranty | date: 'dd/MM/yyyy'}}
            </div>
        </div>
        <div class="vehicle-values flex1 bg-tile text-center">
            <div class="rem-img-fit"><img src="../../../../../../assets/images/service_dmk.svg" alt=""
                    class="img-fluid h-68">
            </div>
            <div class="rem-name">Next Service</div>
            <div class="ft-12 d-flex rem-due">
                <span>Due On&nbsp;</span>{{reminderData?.certificateDetails?.service | date: 'dd/MM/yyyy'}}
            </div>
        </div>
    </div>

    <div class="d-flex w-100">
        <div class="ml-auto disabled">Add +</div>
    </div>
</div>
<p *ngIf="isError">No Data Available</p>